export const formatDateShort = (date) => Intl.DateTimeFormat('default', {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
}).format(new Date(date));

export const formatDateLong = (date) => Intl.DateTimeFormat('default', {
  weekday: 'long',
  month: 'long',
  day: 'numeric',
  year: 'numeric',
}).format(new Date(date));

export const formatDateTimeLong = (date) => Intl.DateTimeFormat('default', {
  weekday: 'long',
  month: 'long',
  day: 'numeric',
  year: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
}).format(new Date(date));

export const formatDateTimeShort = (date) => Intl.DateTimeFormat('default', {
  month: 'short',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
}).format(new Date(date));

export const getDateFromString = (date) => {
  const [year, month, day] = date.split(/t|T/)[0].split(/-/);
  return new Date(year, month - 1, day);
};
